module.exports = __webpack_public_path__ + "static/compost.ea8c9392.jpg";